import { CSSProperties } from 'react';
import Security from '../seguridad';
import { Estados } from './model/Estados';
import { CardHelper, ICardEdit } from './model/ICardEdit';
import { Roles } from '../api/seguridad/model/IRol';
import { MedioPagoListOut } from '../../model/cobranza';

export { Estados };

type IConfigEstados = {
  id: Estados;

  /** color principal de fondo */
  backcolor?: string;
  /** color de fuente */
  forecolor?: string;
  /** color de borde */
  bordercolor?: string;

  /** indica si este estado es posterior a la emisión de vouchers. undefined cuando no se sabe */
  vouchersEmitidos?: boolean;

  /** indica si está permitido evolucionar a un estado */
  allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => boolean;
}

export const ConfigEstados : IConfigEstados[] = [
  { 
    id: Estados.Cotizacion, 
    backcolor: '#e1d5e7', forecolor: '#333333', bordercolor: '#9673a6', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => p.from === CardHelper.estado(info.card) && p.to === Estados.Cotizacion),
  },
  { 
    id: Estados.Seguimiento1, 
    backcolor: '#ffcccc', forecolor: '#333333', bordercolor: '#36393d', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Seguimiento1),
  },
  { 
    id: Estados.Seguimiento2, 
    backcolor: '#ffcccc', forecolor: '#333333', bordercolor: '#36393d', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Seguimiento2),
  },
  { 
    id: Estados.Seguimiento3, 
    backcolor: '#ffcccc', forecolor: '#333333', bordercolor: '#36393d', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Seguimiento3),
  },

  { 
    id: Estados.Anulado, 
    backcolor: '#a20025', forecolor: '#ffffff', bordercolor: '#6F0000',
    vouchersEmitidos: undefined,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Anulado) &&
      Security.HasPermiso(91) &&
      (info.card?.operacion?.motivoanulacion??'').length >= 10,
  },
  { 
    id: Estados.Rechazado, 
    backcolor: '#a20025', forecolor: '#ffffff', bordercolor: '#6F0000', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Rechazado) &&
      ( 
        ( CardHelper.estado(info.card) !== Estados.VerificarPago && Security.HasPermiso(92) )
        || 
        ( CardHelper.estado(info.card) === Estados.VerificarPago && Security.HasPermiso(151) )
      )
  },
  { 
    id: Estados.Cerrado, 
    backcolor: '#647687', forecolor: '#ffffff', bordercolor: '#314354', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Cerrado) &&
      (
        ( // es una cotizacion
          !info.card?.operacion?.id && 
          Security.HasPermiso(96)
        ) ||
        ( // es una operacion
          !!info.card?.operacion?.id && 
          Security.HasPermiso(97)
        )
      )
  },
  { 
    id: Estados.Cobrando, 
    backcolor: '#fff2cc', forecolor: '#000000', bordercolor: '#d6b656', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      false, // no se puede pasar manualmente a este estado
      //&& !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Cobrando), 
  },
  { 
    id: Estados.Pendiente, 
    backcolor: '#f5f5f5', forecolor: '#333333', bordercolor: '#666666', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Pendiente) &&
      (
        ( CardHelper.estado(info.card) === Estados.Rechazado && Security.HasPermiso(147) )
      )
  },
  { 
    id: Estados.VerificarPago, 
    backcolor: '#ffe6cc', forecolor: '#000000', bordercolor: '#d79b00', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => {
      console.log("A VERIFICAR PAGO - allow", info.card?.operacionpago, CardHelper.estado(info.card),maestro.mediospagos) 
      return !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.VerificarPago) &&
      (
        CardHelper.estado(info.card) === Estados.Pendiente &&
        !!info.card?.operacionpago?.fecha && 
        !!info.card?.operacionpago?.referencia && 
        !!info.card?.operacionpago?.idmediopago && 
        !!maestro.mediospagos.some(p => p.id === info.card?.operacionpago?.idmediopago && !!(p.verificarPago) && !p.inhabilitadoFecha)    // necesita verificar pago
      )
    }
  },
  { 
    id: Estados.Emitir, 
    backcolor: '#d5e8d4', forecolor: '#000000', bordercolor: '#82b366', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => {
      console.log("A EMITIR - allow", info.card?.operacionpago, CardHelper.estado(info.card),Security.HasPermiso(89),maestro.mediospagos.some(p => p.id === info.card?.operacionpago?.idmediopago && !p.verificarPago && !p.inhabilitadoFecha), maestro )
      const idTelefonicamente = maestro.mediospagos?.find(p => p.codigo === "ACT001")?.id;
      /*console.log(
        "A EMITIR!!",
        CardHelper.estado(info.card) === Estados.Pendiente,
        Security.HasPermiso(89),
        !!info.card?.operacionpago?.fecha,
        !!info.card?.operacionpago?.referencia,
        !!info.card?.operacionpago?.idmediopago,
        (!!idTelefonicamente && info.card?.operacionpago?.idmediopago !== idTelefonicamente),
        !!maestro.mediospagos.some(p => p.id === info.card?.operacionpago?.idmediopago && !(p.verificarPago) && !p.inhabilitadoFecha)
      )*/
      return !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Emitir) &&
      (
        (
          ([Estados.Pendiente, Estados.ErrorEmitiendo].includes(CardHelper.estado(info.card)!)) && 
          Security.HasPermiso(89) &&
          !!info.card?.operacionpago?.fecha && 
          !!info.card?.operacionpago?.referencia && 
          !!info.card?.operacionpago?.idmediopago && 
          (!!idTelefonicamente && info.card.operacionpago.idmediopago !== idTelefonicamente) && // Medio de pago no puede ser "Telefónicamente"
          !!maestro.mediospagos.some(p => p.id === info.card?.operacionpago?.idmediopago && !(p.verificarPago) && !p.inhabilitadoFecha)    // no necesite verificar pago
        ) ||
        (
          CardHelper.estado(info.card) === Estados.VerificarPago && 
          Security.HasPermiso(151) &&
          !!info.card?.operacionpago?.fecha && 
          !!info.card?.operacionpago?.referencia
        )
      )
    },
  },  
  { 
    id: Estados.ErrorEmitiendo, 
    backcolor: '#a0522d', forecolor: '#ffffff', bordercolor: '#6D1F00', 
    vouchersEmitidos: false,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      false, //&& !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.ErrorEmitiendo), 
  },
  { 
    id: Estados.ErrorEnviarVoucher, 
    backcolor: '#a0522d', forecolor: '#ffffff', bordercolor: '#6D1F00', 
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      false, //&& !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.ErrorEnviarVoucher), 
  },
  { 
    id: Estados.Emitido, 
    backcolor: '#97D077', forecolor: '#000000', bordercolor: '#82b366', 
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Emitido) &&
      Security.HasPermiso(90) &&
      (info?.card?.operacionvouchers?.length ?? 0) > 0,
  },
  { 
    id: Estados.Facturar, 
    backcolor: '#cdeb8b', forecolor: '#000000', bordercolor: '#36393d', 
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      Security.HasOneRolOf([Roles.Admin, Roles.Administracion]) &&
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Facturar), 
  },
  { 
    id: Estados.Facturado, 
    backcolor: '#dae8fc', forecolor: '#000000', bordercolor: '#6c8ebf', 
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      Security.HasRol(Roles.Admin) &&
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Facturado),
  },
  { 
    id: Estados.Finalizado, 
    backcolor: '#0050ef', forecolor: '#ffffff', bordercolor: '#001DBC', 
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      Security.HasRol(Roles.Admin) &&
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Finalizado), 
  },
  { 
    id: Estados.Devuelto,  
    backcolor: '#a20025', forecolor: '#ffffff', bordercolor: '#6F0000',
    vouchersEmitidos: true,
    allow: (info: { card: ICardEdit | null | undefined }, maestro: { mediospagos: MedioPagoListOut[] }) => 
      Security.HasRol(Roles.Admin) &&
      !!WorkflowEstado.workflow.find(p => (p.from === CardHelper.estado(info.card)) && p.to === Estados.Devuelto) &&
      (info.card?.operacion?.motivodevolucion??'').length >= 10,
  },
];

/** Todos los id's de Estados */
export const AllEstados = ConfigEstados.map(p => p.id);

/** obtiene la configuración de un estado */
export const GetConfigEstado = (estado?: Estados) => ConfigEstados.find(p => p.id === estado);

/** obtiene los estilos de un Email Template */
export const GetStyleEstado = (estado?: Estados, def?: CSSProperties) => 
  ((cfg) : CSSProperties | undefined => !!cfg ? ({ backgroundColor: cfg?.backcolor, border: `1px solid ${cfg?.bordercolor}`, color: cfg?.forecolor }) : def)(ConfigEstados.find(p => p.id === estado));

export const WorkflowEstado = {
  workflow: [
    { from: undefined, to: Estados.Cotizacion },
    { from: undefined, to: Estados.Cobrando },
    { from: undefined, to: Estados.Pendiente },
    { from: undefined, to: Estados.Rechazado },
    { from: undefined, to: Estados.Emitir },  // se pagó con ok inmediato
    
    { from: Estados.Cotizacion, to: Estados.Seguimiento1},
    { from: Estados.Cotizacion, to: Estados.Cerrado},
    { from: Estados.Cotizacion, to: Estados.Pendiente},

    { from: Estados.Seguimiento1, to: Estados.Seguimiento2},
    { from: Estados.Seguimiento1, to: Estados.Cerrado},
    { from: Estados.Seguimiento1, to: Estados.Pendiente},

    { from: Estados.Seguimiento2, to: Estados.Seguimiento3},
    { from: Estados.Seguimiento2, to: Estados.Cerrado},
    { from: Estados.Seguimiento2, to: Estados.Pendiente},

    { from: Estados.Seguimiento3, to: Estados.Cerrado},
    { from: Estados.Seguimiento3, to: Estados.Pendiente},

    { from: Estados.Rechazado, to: Estados.Cerrado },
    { from: Estados.Rechazado, to: Estados.Pendiente },

    { from: Estados.Cobrando, to: Estados.Cobrando },
    { from: Estados.Cobrando, to: Estados.Pendiente },
    { from: Estados.Cobrando, to: Estados.Cerrado },
    { from: Estados.Cobrando, to: Estados.Rechazado },
    { from: Estados.Cobrando, to: Estados.Emitir },

    { from: Estados.Pendiente, to: Estados.Cobrando },
    { from: Estados.Pendiente, to: Estados.Pendiente },
    { from: Estados.Pendiente, to: Estados.Cerrado },
    { from: Estados.Pendiente, to: Estados.Rechazado },
    { from: Estados.Pendiente, to: Estados.Emitir },
    { from: Estados.Pendiente, to: Estados.VerificarPago },

    { from: Estados.Emitir, to: Estados.Pendiente },    // ocurre cuando se cambian los datos de la cotización (imposible para el usuario a mano)
    { from: Estados.Emitir, to: Estados.Emitir },
    { from: Estados.Emitir, to: Estados.Emitido },
    { from: Estados.Emitir, to: Estados.Anulado },
    { from: Estados.Emitir, to: Estados.ErrorEmitiendo },

    { from: Estados.ErrorEmitiendo, to: Estados.Emitir },
    { from: Estados.ErrorEmitiendo, to: Estados.Emitido }, // pasaje manual

    { from: Estados.ErrorEnviarVoucher, to: Estados.Emitido },

    { from: Estados.Emitido, to: Estados.Facturar },
    { from: Estados.Emitido, to: Estados.ErrorEnviarVoucher },
    { from: Estados.Emitido, to: Estados.Pendiente },   // ocurre cuando se cambian los datos de la cotización (imposible para el usuario a mano)
    
    { from: Estados.VerificarPago, to: Estados.Emitir },
    { from: Estados.VerificarPago, to: Estados.Rechazado },

    { from: Estados.Facturar, to: Estados.Facturado },
    { from: Estados.Facturar, to: Estados.Anulado },

    { from: Estados.Facturado, to: Estados.Devuelto },
    { from: Estados.Facturado, to: Estados.Finalizado },
  ],

  /** devuelve la lista de estados a los que se puede evolucionar en el workflow */
  nexts: (estado?: Estados) : Estados[] => WorkflowEstado.workflow.filter(p => p.from === estado).map(p => p.to),

  estadosYaEmitidos: [Estados.Emitido, Estados.ErrorEnviarVoucher, Estados.Facturar, Estados.Facturado, Estados.Finalizado, Estados.Devuelto, Estados.Anulado],
}
